import { AbstractRepository } from '../../../services/AbstractRepository';
import { BootstrapState } from './enums';
import { IShellDAO } from '../../../dao/IShellDAO';

export interface BootstrapStateData {
  state: BootstrapState;
  timestamp: number;
  message?: string;
  error?: string;
}

export class BootstrapRepository extends AbstractRepository<BootstrapStateData> {
  private static readonly BOOTSTRAP_STATE_KEY = 'bootstrap_state';

  constructor(shellDAO: IShellDAO, enableSanitizer = false) {
    super({
      shellDAO,
      prefixKey: 'bootstrap',
      enableSanitizer,
      defaultTTL: 3600 // 1 hour TTL for bootstrap state
    });
  }

  /**
   * Sets the bootstrap state in storage
   */
  setState(stateData: BootstrapStateData): void {
    this.save(BootstrapRepository.BOOTSTRAP_STATE_KEY, stateData);
  }

  /**
   * Gets the current bootstrap state from storage
   */
  getState(): BootstrapStateData | null {
    const state = this.findOne(BootstrapRepository.BOOTSTRAP_STATE_KEY);
    return state || null;
  }

  /**
   * Clears the bootstrap state from storage
   */
  clearState(): boolean {
    return this.delete(BootstrapRepository.BOOTSTRAP_STATE_KEY);
  }

  /**
   * Checks if bootstrap state exists in storage
   */
  hasState(): boolean {
    const state = this.getState();
    return state !== null;
  }
}
